import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CONSTANTES } from "../shared/global";
import { InfoUser } from '../models/InfoUser';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    

    public url: string;

    constructor(private http: HttpClient) {
        this.url = CONSTANTES.api_url + "/users";
    }

    getUser(cip: string) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.get<InfoUser>(this.url + "/info/" + cip, { headers: iheaders });
    }

    changeUserInfo(userInfo: Object) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.post<InfoUser>(this.url + "/changeUser/" ,JSON.stringify(userInfo) ,{headers: iheaders});
      }

}


